export enum EStatusMedicineImport {
  Active = 'active',
  DeActive = 'de_active'
}
